import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import Fuse from 'fuse.js';
import { createCrudAtoms } from './utils/crudFactory';

type Company = {
  id: string;
  name: string;
};

export const companiesAtom = atom<Company[]>([]);

export const selectedCompanyIdAtom = atomWithStorage<string | null>('company-id', null);

export const selectedCompanyAtom = atom<Company | null>((get) => {
  const companies = get(companiesAtom);
  const selectedCompanyId = get(selectedCompanyIdAtom);
  return companies.length > 0 ? companies.find((c) => c.id === selectedCompanyId) || null : null;
});

export const companySearchQueryAtom = atom('');

// Derived atom: Fuzzy search for clubs & locations
export const filteredCompaniesAtom = atom((get) => {
  const companies = get(companiesAtom);
  const searchQuery = get(companySearchQueryAtom).trim();

  if (!searchQuery) return companies;

  const fuse = new Fuse(companies, {
    keys: ['name'],
    threshold: 0.3, // Adjust sensitivity (lower = stricter matches)
    includeMatches: true, // Include match details (for highlighting)
  });

  const results = fuse.search(searchQuery);

  return results;
});

export const {
  addAtom: addCompanyAtom,
  updateAtom: updateCompanyAtom,
  deleteAtom: deleteCompanyAtom,
} = createCrudAtoms<Company>('companies');
